// Brazilian phone mask: formats raw digits into "(XX) XXXX-XXXX" (10 digits,
// landline) or "(XX) XXXXX-XXXX" (11 digits, mobile). Anything beyond 11 is
// truncated. Apply this on every keystroke for live formatting.
export function formatBrazilianPhone(raw: string): string {
  const digits = raw.replace(/\D/g, '').slice(0, 11);
  if (digits.length === 0) return '';
  if (digits.length <= 2) return `(${digits}`;
  if (digits.length <= 6) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
  }
  if (digits.length <= 10) {
    return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6)}`;
  }
  return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7)}`;
}

/** True when the user has entered enough digits to be a valid BR phone. */
export function isPhoneInputComplete(raw: string): boolean {
  const digits = raw.replace(/\D/g, '');
  return digits.length === 10 || digits.length === 11;
}

/**
 * Detecta padrões que geralmente são bug de auto-fill do Chrome (que às
 * vezes mascara "+55 21994-8183" como DDD 55 · celular Anatel exige 3º
 * dígito = 9). Se true, mostra warning pra usuário confirmar.
 */
export function isSuspiciousBrPhone(raw: string): boolean {
  const digits = raw.replace(/\D/g, '');
  if (digits.length !== 11) return false;
  // Celular BR exige 9 como 3º dígito · sem isso é bug de auto-fill
  return digits.charAt(2) !== '9';
}
